(() => {
  const DESKTOP_MQ = window.matchMedia("(min-width: 990px)");

  const px = (v) => (Number.isFinite(v) ? v : 0);

  function getGapPx(el) {
    const cs = getComputedStyle(el);
    // flex gap suele venir en rowGap (o gap)
    const gap = parseFloat(cs.rowGap || cs.gap || "0");
    return px(gap);
  }

  function setDisabled(btn, disabled) {
    btn.toggleAttribute("disabled", disabled);
    btn.setAttribute("aria-disabled", disabled ? "true" : "false");

    // Dawn usa data-disabled en algunos casos
    if (disabled) btn.setAttribute("data-disabled", "");
    else btn.removeAttribute("data-disabled");
  }

  function clearDawnInlineHiding(btn) {
    // Dawn mete inline styles tipo visibility:hidden; pointer-events:none; opacity:.4
    btn.style.removeProperty("visibility");
    btn.style.removeProperty("pointer-events");
    btn.style.removeProperty("opacity");
  }

  function initThumbsLeft(gallery) {
    if (!gallery || gallery.dataset.thumbsLeftVerticalInit === "true") return;
    gallery.dataset.thumbsLeftVerticalInit = "true";

    const layout = gallery.querySelector(".media-gallery__layout");
    const thumbSlider = layout?.querySelector("slider-component.thumbnail-slider");
    const viewer = layout?.querySelector("slider-component:not(.thumbnail-slider)");
    const thumbList = thumbSlider?.querySelector(".thumbnail-list");
    const prevBtn = thumbSlider?.querySelector(".slider-button--prev");
    const nextBtn = thumbSlider?.querySelector(".slider-button--next");

    if (!layout || !thumbSlider || !viewer || !thumbList || !prevBtn || !nextBtn) return;

    const stepCount = (btn) => {
      const n = parseInt(btn.dataset.step || "1", 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    };

    const stepPx = (btn) => {
      const firstItem = thumbList.querySelector(".thumbnail-list__item");
      const itemH = firstItem ? firstItem.getBoundingClientRect().height : 0;
      const gap = getGapPx(thumbList);
      return Math.max(1, (itemH + gap) * stepCount(btn));
    };

    const updateButtons = () => {
      if (!DESKTOP_MQ.matches) return;

      clearDawnInlineHiding(prevBtn);
      clearDawnInlineHiding(nextBtn);

      const maxTop = thumbList.scrollHeight - thumbList.clientHeight;
      const scrollable = maxTop > 1;

      // si no hay scroll, escondemos botones (pero sin depender del JS de Dawn)
      prevBtn.style.visibility = scrollable ? "visible" : "hidden";
      nextBtn.style.visibility = scrollable ? "visible" : "hidden";

      const atTop = thumbList.scrollTop <= 1;
      const atBottom = thumbList.scrollTop >= maxTop - 1;

      setDisabled(prevBtn, !scrollable || atTop);
      setDisabled(nextBtn, !scrollable || atBottom);
    };

    const updateMaxHeight = () => {
      if (!DESKTOP_MQ.matches) return;

      // Altura del viewer (columna derecha)
      const viewerH = viewer.getBoundingClientRect().height;

      // Restamos alto de botones + gaps del contenedor
      const prevH = prevBtn.getBoundingClientRect().height;
      const nextH = nextBtn.getBoundingClientRect().height;
      const sliderGap = getGapPx(thumbSlider);

      const available = Math.max(0, viewerH - prevH - nextH - sliderGap * 2);

      // tu CSS lee --thumbs-left-max-h
      gallery.style.setProperty("--thumbs-left-max-h", `${available}px`);

      updateButtons();
    };

    const scrollByDir = (dir, btn) => {
      const amount = stepPx(btn) * dir;
      thumbList.scrollBy({ top: amount, behavior: "smooth" });
    };

    // IMPORTANT: capturamos el click para que NO corra el handler del slider-component (horizontal)
    prevBtn.addEventListener(
      "click",
      (e) => {
        if (!DESKTOP_MQ.matches) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        scrollByDir(-1, prevBtn);
      },
      true
    );

    nextBtn.addEventListener(
      "click",
      (e) => {
        if (!DESKTOP_MQ.matches) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        scrollByDir(1, nextBtn);
      },
      true
    );

    thumbList.addEventListener(
      "scroll",
      () => {
        if (!DESKTOP_MQ.matches) return;
        requestAnimationFrame(updateButtons);
      },
      { passive: true }
    );

    // Mantener el thumbnail activo visible (cuando cambia aria-current)
    const mo = new MutationObserver(() => {
      if (!DESKTOP_MQ.matches) return;

      const activeBtn = thumbList.querySelector("button.thumbnail[aria-current='true']");
      if (activeBtn) activeBtn.scrollIntoView({ block: "nearest" });

      updateButtons();
    });

    mo.observe(thumbList, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-current", "class"],
    });

    // Recalcular alturas al cargar/resize/cambios de tamaño
    const ro = new ResizeObserver(() => updateMaxHeight());
    ro.observe(viewer);
    ro.observe(thumbSlider);

    window.addEventListener("load", updateMaxHeight);
    requestAnimationFrame(updateMaxHeight);

    // Cuando entras/sales de desktop
    if (DESKTOP_MQ.addEventListener) {
      DESKTOP_MQ.addEventListener("change", () => requestAnimationFrame(updateMaxHeight));
    } else if (DESKTOP_MQ.addListener) {
      DESKTOP_MQ.addListener(() => requestAnimationFrame(updateMaxHeight));
    }
  }

  function boot() {
    document
      .querySelectorAll("media-gallery.media-gallery--thumbs-left")
      .forEach((gallery) => initThumbsLeft(gallery));
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", boot);
})();
